const initialState = {
  data: { total: 0, data: { result: [], totalPrice: 0 } },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_DATA":
      return { ...state, data: action.data };
    case "CLEAR_DATA":
      return initialState;
    default:
      return state;
  }
}